var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5163 4.18926C12.2175 3.93691 11.7825 3.93691 11.4837 4.18926L2.71807 11.6268C2.38272 11.9123 2.34287 12.4137 2.6251 12.749C2.90732 13.0844 3.41201 13.1242 3.74736 12.842L4.56416 12.1514V18.3438C4.56416 19.8113 5.75283 21 7.22041 21H16.7829C18.2505 21 19.4392 19.8113 19.4392 18.3438V12.1514L20.2526 12.842C20.588 13.1275 21.0927 13.0844 21.3749 12.749C21.6571 12.4137 21.6173 11.909 21.2819 11.6268L12.5163 4.18926ZM6.15791 18.3438V10.8L12.0017 5.84277L17.8454 10.8V18.3438C17.8454 18.9314 17.3706 19.4062 16.7829 19.4062H15.1892V14.3594C15.1892 13.6256 14.5948 13.0312 13.861 13.0312H10.1423C9.4085 13.0312 8.81416 13.6256 8.81416 14.3594V19.4062H7.22041C6.63272 19.4062 6.15791 18.9314 6.15791 18.3438ZM10.4079 19.4062V14.625H13.5954V19.4062H10.4079Z",
    fill: "#040404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffersIcon);
export default __webpack_public_path__ + "static/media/offersIcon.8c132289a74dd7a4575c983bda5bf490.svg";
export { ForwardRef as ReactComponent };